import { render, staticRenderFns } from "./lgsfList.vue?vue&type=template&id=7bd3f02e&scoped=true&"
import script from "./lgsfList.vue?vue&type=script&lang=js&"
export * from "./lgsfList.vue?vue&type=script&lang=js&"
import style0 from "./lgsfList.vue?vue&type=style&index=0&id=7bd3f02e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd3f02e",
  null
  
)

export default component.exports